import angular from 'angular';

import SiteOperationalStatusDeviceListComponent from './site-operational-status-device-list-component';

export default angular
  .module('site-operational-status-device-list', [])
  .component('siteOperationalStatusDeviceList', new SiteOperationalStatusDeviceListComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/site-operational-status/components/site-operational-status-device-list/site-operational-status-device-list-module.js